module.exports = __webpack_public_path__ + "img/bubble10.6d68539e.png";